/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolTimerIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-timer"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M10.03 3.1Q9.47 3.1 9.09 2.71Q8.7 2.33 8.7 1.77Q8.7 1.23 9.09 0.84Q9.47 0.45 10.03 0.45L13.97 0.45Q14.53 0.45 14.91 0.84Q15.3 1.23 15.3 1.77Q15.3 2.33 14.91 2.71Q14.53 3.1 13.97 3.1ZM12 14.85Q12 14.85 12.28 14.85Q12.55 14.85 12.94 14.46Q13.32 14.07 13.32 13.53L13.32 9.57Q13.32 9.03 12.94 8.64Q12.55 8.25 12 8.25Q11.45 8.25 11.06 8.64Q10.68 9.03 10.68 9.57L10.68 13.53Q10.68 14.07 11.06 14.46Q11.45 14.85 12 14.85ZM12 23.25Q12 23.25 11 23.25Q10 23.25 8.25 22.49Q6.5 21.73 5.19 20.41Q3.88 19.1 3.11 17.35Q2.35 15.6 2.35 13.6Q2.35 11.6 3.11 9.85Q3.88 8.1 5.19 6.79Q6.5 5.47 8.25 4.71Q10 3.95 12 3.95Q13.57 3.95 15.04 4.42Q16.5 4.9 17.77 5.85L18.52 5.1Q18.93 4.7 19.46 4.7Q20 4.7 20.4 5.1Q20.8 5.5 20.8 6.04Q20.8 6.58 20.4 6.97L19.65 7.72Q20.68 9.07 21.16 10.55Q21.65 12.03 21.65 13.6Q21.65 15.6 20.89 17.35Q20.13 19.1 18.81 20.41Q17.5 21.73 15.75 22.49Q14 23.25 12 23.25Z" fill={color} />
    </svg>
  );
}
